// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"760":"78e167d5","1981":"4dfb4586","2798":"4dfb4586","4682":"4dfb4586","6467":"4dfb4586","6568":"4dfb4586","7497":"4dfb4586","7862":"be3a801c","9314":"4dfb4586","9935":"4dfb4586"}[chunkId] + ".chunk.css";
};